import { commonConfig, CommonConfigKeys } from './common.config'
import { ConfigType } from './types'

export type TestEnvConfigKeys = CommonConfigKeys

export const testConfig: ConfigType = commonConfig
